import { render, staticRenderFns } from "./RelatoriosTesteResultsPanel.vue?vue&type=template&id=10f1412c&scoped=true&"
import script from "./RelatoriosTesteResultsPanel.vue?vue&type=script&lang=js&"
export * from "./RelatoriosTesteResultsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1412c",
  null
  
)

export default component.exports